import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeStudentOfSubject(_id:$_id){
        recordId
      }
}
`
